// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanSummaryDto } from './IPlanSummaryDto';
import {
    IPlanSummaryDtoFromJSON,
    IPlanSummaryDtoFromJSONTyped,
    IPlanSummaryDtoToJSON,
    IPlanSummaryDtoToJSONTyped,
} from './IPlanSummaryDto';

/**
 * 
 * @export
 * @interface IScheduledContributionSummaryDto
 */
export interface IScheduledContributionSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof IScheduledContributionSummaryDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionSummaryDto
     */
    calendar_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IScheduledContributionSummaryDto
     */
    frequency_type?: IScheduledContributionSummaryDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledContributionSummaryDto
     */
    next_scheduled_date?: Date;
    /**
     * 
     * @type {Array<IPlanSummaryDto>}
     * @memberof IScheduledContributionSummaryDto
     */
    plan_summaries?: Array<IPlanSummaryDto>;
}

/**
* @export
* @enum {string}
*/
export enum IScheduledContributionSummaryDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}


/**
 * Check if a given object implements the IScheduledContributionSummaryDto interface.
 */
export function instanceOfIScheduledContributionSummaryDto(value: object): value is IScheduledContributionSummaryDto {
    return true;
}

export function IScheduledContributionSummaryDtoFromJSON(json: any): IScheduledContributionSummaryDto {
    return IScheduledContributionSummaryDtoFromJSONTyped(json, false);
}

export function IScheduledContributionSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScheduledContributionSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'calendar_name': json['calendar_name'] == null ? undefined : json['calendar_name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'next_scheduled_date': json['next_scheduled_date'] == null ? undefined : (new Date(json['next_scheduled_date'])),
        'plan_summaries': json['plan_summaries'] == null ? undefined : ((json['plan_summaries'] as Array<any>).map(IPlanSummaryDtoFromJSON)),
    };
}

export function IScheduledContributionSummaryDtoToJSON(json: any): IScheduledContributionSummaryDto {
    return IScheduledContributionSummaryDtoToJSONTyped(json, false);
}

export function IScheduledContributionSummaryDtoToJSONTyped(value?: IScheduledContributionSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'calendar_name': value['calendar_name'],
        'frequency_type': value['frequency_type'],
        'next_scheduled_date': value['next_scheduled_date'] == null ? undefined : ((value['next_scheduled_date']).toISOString().substring(0,10)),
        'plan_summaries': value['plan_summaries'] == null ? undefined : ((value['plan_summaries'] as Array<any>).map(IPlanSummaryDtoToJSON)),
    };
}

